module.exports = __webpack_public_path__ + "static/media/france.bcd389de.svg";